import {NineSliceBorders} from '@fantasmagames/core/src/loader/ResourcesLoader';
import {Position} from '@fantasmagames/slot/src/modules/reels/ReelConstants';

export interface INineSliceTextureAndBorders {
	texture: PIXI.Texture;
	nine: NineSliceBorders;
}

export class NineSlicePlane extends PIXI.mesh.NineSlicePlane {
	protected _anchor: Position = {x: 0.5, y: 0.5};

	constructor(texture: PIXI.Texture, nineSliceBorders: NineSliceBorders) {
		super(texture, nineSliceBorders.leftWidth, nineSliceBorders.topHeight, nineSliceBorders.rightWidth, nineSliceBorders.bottomHeight);

		this.updatePositionFromAnchor();
	}

	public updatePositionFromAnchor(): void {
		this.position.x = -(this.width * this._anchor.x);
		this.position.y = -(this.height * this._anchor.y);
	}

	public set anchor(newAnchor: Position) {
		this._anchor = newAnchor;
		this.updatePositionFromAnchor();
	}
}

export class NineSlicePlaneFromObject extends NineSlicePlane {
	constructor(nineSliceObject: INineSliceTextureAndBorders) {
		super(nineSliceObject.texture, nineSliceObject.nine);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/display/NineSlicePlane.ts